import { z } from 'zod';

export enum ExportExternalDocumentPacketReasons {
  FailedMedicalNecessity = 'FailedMedicalNecessity',
  OutOfScope = 'OutOfScope',
}

const validateNoDirectoryTraversal = (filePath: string | undefined) => {
  if (!filePath) return true;
  if (filePath.includes('../') || filePath.includes('..\\')) {
    return false;
  }
  return true;
};

export const ExportExternalDocumentPacketBlockConfigSchema = z.object({
  externalDocumentPacket: z.object({
    sourceBlockName: z.string(),
  }),
  exportReason: z.nativeEnum(ExportExternalDocumentPacketReasons),
  filePath: z.string().optional().refine(validateNoDirectoryTraversal, {
    message: 'Directory traversal attempts (../) are not allowed in file paths',
  }),
});

export type ExportExternalDocumentPacketBlockConfig = z.infer<
  typeof ExportExternalDocumentPacketBlockConfigSchema
>;
